import { Container, CssBaseline } from "@mui/material";
import { Fragment } from "react";
import { Outlet } from "react-router-dom";


const ClientLayout = () => {
    return (
        <Fragment>
            <CssBaseline/>
            <Container maxWidth="lg">
                <Outlet />
            </Container>

        </Fragment>
    )
}

export default ClientLayout;